import {
  START_LOADING, DELETE_PROJECT, GET_PROJECTS_LIST,
  GET_PROJECT_DATA,
  EDIT_PROJECT, CREATE_PROJECT, ERROR,
  STOP_LOADING, YEAR_LIST,
  GET_AVAILABLE_CONSULTANTS,
  PROJECT_PLANS_FOR_YEAR,
  INVOICES_DATA,
  BUILD_INVOICE,
  ACTIVITIES_DATA,
  FILTERED_INVOICES,
  GET_FOROWN_LIST,
  GET_FOROTHER_LIST,
  LOGIN_ERROR,
  GET_USER_FOR_PM,
  COMPARE_LIST
} from "../ProjectsAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false,
  error_message: ''
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_PROJECTS_LIST:
      return {
        ...state,
        projects_list: action.payload,
        loading: false,
        success: false
      }
    case GET_USER_FOR_PM:
      return {
        ...state,
        user_list_for_pm: action.payload,
        loading: false,
        success: false
      }
    case LOGIN_ERROR:
      return {
        ...state,
        login_error: action.payload,
        loading: false,
        success: false
      }
    case GET_FOROWN_LIST:
      return {
        ...state,
        forown_list: action.payload,
        loading: false,
        success: false
      }
    case GET_FOROTHER_LIST:
      return {
        ...state,
        forother_list: action.payload,
        loading: false,
        success: false
      }
    case GET_PROJECT_DATA:
      return {
        ...state,
        project_data: action.payload,
        loading: false,
        success: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case CREATE_PROJECT:
      return {
        ...state,
        new_project: action.payload,
        loading: false
      }
    case EDIT_PROJECT:
      return {
        ...state,
        edited_project: action.payload,
        loading: false
      }
    case DELETE_PROJECT:
      return {
        ...state,
        success: true,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    case YEAR_LIST:
      return {
        ...state,
        year_list: action.payload,
        loading: false
      }
    case COMPARE_LIST:
      return {
        ...state,
        compare_list: action.payload,
        loading: false
      }
    case GET_AVAILABLE_CONSULTANTS:
      return {
        ...state,
        available_consultant: action.payload,
        loading: false
      }
    case PROJECT_PLANS_FOR_YEAR:
      return {
        ...state,
        project_plans_for_year: action.payload.project_plans,
        rest_gemsat: action.payload.rest_gemsat,
        rest_year: action.payload.rest_year,
        loading: false
      }
    case INVOICES_DATA:
      return {
        ...state,
        project_invoices: action.payload.invoices,
        project_invoices_summary: action.payload.summary,
        loading: false
      }
    case FILTERED_INVOICES:
      return {
        ...state,
        filtered_invoices: action.payload,
        loading: false
      }
    case ACTIVITIES_DATA:
      return {
        ...state,
        project_activities: action.payload,
        loading: false
      }
    case BUILD_INVOICE:
      return {
        ...state,
        build_invoice: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}